"use client";

import { useState } from "react";
import { Icon } from "./Icon";

const FAQS = [
	{
		q: "Is Aspen really free?",
		a: "Yes. The core app — bank sync, budgets, categories, and Sage basics — is free during open beta and will stay free. Aspen+ adds unlimited Sage chats and advanced reports later.",
	},
	{
		q: "How do you keep my data safe?",
		a: "We connect via Plaid using bank-level 256-bit encryption, store connections read-only, and never sell your data. Aspen can see transactions but can never move money.",
	},
	{
		q: "Which banks are supported?",
		a: "Over 12,000 institutions through Plaid — including Chase, Amex, Goldman Sachs, Vanguard, Capital One, and most US credit unions. You can also add accounts manually.",
	},
	{
		q: "What is Sage?",
		a: "Sage is your built-in AI finance coach. Ask questions in plain language, get budget suggestions, and receive gentle nudges before you overspend.",
	},
	{
		q: "Do I have to use the gamification features?",
		a: "Right now, streaks, XP, and quests are part of the core Aspen experience — they're woven into how you check in and build habits. Finer controls to dial them down are on our roadmap.",
	},
];

export function Faq() {
	const [open, setOpen] = useState(0);
	return (
		<section className="section faq-section">
			<div className="section-head">
				<div className="eyebrow center">
					<span className="dot" style={{ color: "var(--green)" }} /> Questions
				</div>
				<h2 className="section-title serif">Good to know.</h2>
			</div>
			<div className="faq-list">
				{FAQS.map((f, i) => (
					<div key={f.q} className="faq-item" onClick={() => setOpen(open === i ? -1 : i)}>
						<div className="faq-q">
							<span>{f.q}</span>
							<span className="faq-toggle" style={{ transform: open === i ? "rotate(45deg)" : "none" }}>
								<Icon name="plus" size={16} color="var(--ink-2)" />
							</span>
						</div>
						<div className="faq-a" style={{ maxHeight: open === i ? 200 : 0, opacity: open === i ? 1 : 0 }}>
							<p>{f.a}</p>
						</div>
					</div>
				))}
			</div>
		</section>
	);
}
